import { render, staticRenderFns } from "./TheAdministrativeLocationAddForm.vue?vue&type=template&id=009473b4&"
import script from "./TheAdministrativeLocationAddForm.vue?vue&type=script&lang=js&"
export * from "./TheAdministrativeLocationAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports